import { Component, type ErrorInfo, type ReactNode } from "react";
import {
  getInternalErrorDetails,
  getUserFacingErrorMessage,
  isInternalDebugEnabled,
  logInternalError,
} from "@/lib/safe-error-message";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    logInternalError("ErrorBoundary", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      const debugDetails = getInternalErrorDetails(this.state.error);

      return (
        <div className="min-h-screen flex items-center justify-center bg-background p-6">
          <div className="max-w-lg w-full rounded-lg border bg-card p-6 space-y-3">
            <h1 className="text-lg font-semibold text-foreground">Erro ao carregar a página</h1>
            <p className="text-sm text-muted-foreground">
              {getUserFacingErrorMessage(this.state.error)}
            </p>
            {debugDetails && (
              <pre className="text-xs text-muted-foreground/80 bg-muted/40 rounded p-3 overflow-x-auto whitespace-pre-wrap break-words border border-dashed">
                {debugDetails}
              </pre>
            )}
            {isInternalDebugEnabled() && (
              <p className="text-[11px] text-muted-foreground">
                Modo debug interno ativo (localStorage fabchat_debug=1)
              </p>
            )}
            <button
              type="button"
              className="text-sm text-primary underline"
              onClick={() => window.location.reload()}
            >
              Recarregar
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
